import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Man"
});
const _hoisted_1 = {
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M27.2143 4.09155L27.3059 14.0709L24.306 14.0985L24.2615 9.16575L20.3371 13.0912C22.8415 16.606 22.5171 21.5167 19.364 24.6699C15.8492 28.1846 10.1508 28.1846 6.63604 24.6699C3.12132 21.1551 3.12132 15.4567 6.63604 11.9419C9.78944 8.78854 14.7007 8.46437 18.2155 10.9694L22.1402 7.04443L17.2074 6.99987L17.235 4L27.2143 4.09155ZM17.2426 14.0633C14.8995 11.7201 11.1005 11.7201 8.75736 14.0633C6.41421 16.4064 6.41421 20.2054 8.75736 22.5485C11.1005 24.8917 14.8995 24.8917 17.2426 22.5485C19.5858 20.2054 19.5858 16.4064 17.2426 14.0633Z",
  fill: "black"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var man = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { man as default };
